import React from 'react'

export const Footer = () => {
  return (
    <footer className='bg-secondary'>
      <p>Developed using React by &#169; Harshna Haswani</p>
      <small>All the product images belong to their respective copyright holders</small>

    </footer>
  )
}
